jQuery(document).ready(function ($) {

    $('.read_more_cd7c .faq_question').off('click');
    $('.read_more_cd7c .js-read-more-toggle').off('click');
  
    $(document).on('click', '.read_more_cd7c .js-read-more-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
  
      var $question = $(this);
      var $answer   = $question.prev('.js-read-more-answer');
      var $label    = $question.find('.read-more-label');
  
      if ($question.hasClass('open')) {

        $question.removeClass('open');
        $label.text('Read More');
        $answer.stop(true, true).slideUp().removeClass('show');
  
      } else {

        $question.addClass('open');
        $label.text('Read Less');
        $answer.stop(true, true).slideDown().addClass('show');
      }
  
    });
  
});
  